module.exports = __webpack_public_path__ + "img/background.8bb1ed75.jpg";